export const fillRange = (min: number, max: number): number[] => {
    const range = [];
    for (let i = min; i <= max; i++) {
        range.push(i);
    }
    return range;
};
